export default __webpack_public_path__ + "static/media/impact.f5fbad3b.gif";